import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * GS Brand mark.
 * - If /logo.png (or /logo.svg) exists in public/, use it.
 * - Otherwise, fall back to the built-in "G+" badge.
 * Just drop your file at /app/frontend/public/logo.png to replace the mark everywhere.
 */
export function BrandLogo({ variant = "header", className = "" }) {
  const [logo, setLogo] = useState(null); // null=checking, ""=none, url=found

  useEffect(() => {
    const candidates = ["/logo.svg", "/logo.png"];
    let cancelled = false;
    (async () => {
      for (const url of candidates) {
        try {
          const r = await fetch(url, { method: "HEAD" });
          const ct = r.headers.get("content-type") || "";
          if (r.ok && ct.startsWith("image/") && !cancelled) { setLogo(url); return; }
        } catch (error) {
          // Missing logo file is expected (falls back to text mark); log for diagnostics only.
          console.debug(`BrandLogo: candidate ${url} unavailable`, error);
        }
      }
      if (!cancelled) setLogo("");
    })();
    return () => { cancelled = true; };
  }, []);

  if (variant === "footer") {
    if (logo)
      return <img src={logo} alt="GIRO+SAÚDE" className={`h-16 w-auto ${className}`}/>;
    return (
      <div className={`text-2xl font-extrabold text-white ${className}`} style={{fontFamily:"Plus Jakarta Sans"}}>
        GIRO<span className="text-[#FF7D54]">+</span>SAÚDE
      </div>
    );
  }

  if (variant === "hero") {
    if (logo)
      return <img src={logo} alt="GIRO+SAÚDE" className={`h-56 sm:h-72 w-auto drop-shadow-2xl ${className}`}/>;
    return null;
  }

  // header (default)
  return (
    <Link to="/" data-testid="header-logo" className={`flex items-center gap-2 ${className}`}>
      {logo ? (
        <img src={logo} alt="GIRO+SAÚDE" className="h-14 w-auto"/>
      ) : (
        <>
          <div className="w-9 h-9 rounded-xl bg-[#0D7C66] flex items-center justify-center text-white font-bold">G+</div>
          <div className="leading-tight">
            <div className="font-extrabold tracking-tight text-slate-900" style={{fontFamily:"Plus Jakarta Sans"}}>
              GIRO<span className="text-[#FF7D54]">+</span>SAÚDE
            </div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Baixada Santista</div>
          </div>
        </>
      )}
    </Link>
  );
}
